function initMitoSection(sectionId) {
    const sectionElement = document.querySelector(`.mito-section[data-section-id="${sectionId}"]`);
    if (!sectionElement) return;

    const mitoItems = sectionElement.querySelectorAll('.mito-item');
    const descriptionTitle = sectionElement.querySelector(`#title-${sectionId}`);
    const descriptionText = sectionElement.querySelector(`#text-${sectionId}`);
    const iconWrappers = sectionElement.querySelectorAll('.mito-icon-wrapper');

    // Function to update the description area
    const updateDescription = (item) => {
        const title = item.dataset.title;
        const text = item.dataset.text;
        
        // Update the content using the data attributes from the Liquid block
        if (descriptionTitle && title) {
            descriptionTitle.textContent = title;
        }
        if (descriptionText && text) {
            descriptionText.textContent = text;
        }
    };

    // Add click event listeners to each mito-item
    mitoItems.forEach(item => {
        item.addEventListener('click', () => {
            // Remove 'active' class from all items
            mitoItems.forEach(i => i.classList.remove('active'));
            iconWrappers.forEach(iw => iw.classList.remove('blue-gradient')); 

            // Add 'active' class to the clicked item
            item.classList.add('active');

            // Add gradient to the icon wrapper of the clicked item
            const clickedIconWrapper = item.querySelector('.mito-icon-wrapper');
            clickedIconWrapper.classList.add('blue-gradient');

            // Update the description area
            updateDescription(item);
        });
    });

    // Handle initial state and URL update if needed (optional)
    // Find the initially active item and set the description based on it.
    const initialActiveItem = sectionElement.querySelector('.mito-item.active');
    if (initialActiveItem) {
        updateDescription(initialActiveItem);
    }
}

// Attach the JS file globally to load the function definitions
// The function is called per section instance via the Liquid file.